import { observable, action } from "mobx";
import * as services from "../services/production";
import { isDataExist } from "utils/dataTools";
import { message } from "antd";
import { omit } from "lodash";

class Production {
  @observable isLoading = false;
  @observable planNo = "";
  @observable planList = [];
  @observable planPageInfo = {
    pageIndex: 1,
    pageSize: 10
  };
  @observable selectedRowKeys = [];
  @observable selectedRows = [];
  @observable planStatus = "add"; //记录计划弹窗状态
  @observable planModalVis = false;
  @observable addPlanModalVis = false;
  // 2新
  @observable paiChengVis = false;
  @observable paiChengData = [];
  @observable printModalVis = false;
  @observable plan_orderList = [];
  @observable plan_bomList = [];
  @observable route_bomList = [];
  @observable planByOrder = {};
  @observable planCurrentRe = {}; // 编辑当前的record
  @observable planSelectKeys = [];
  @observable schedData = []; // 排程数据的获取
  @observable modalLoading = false;
  @observable isPlantLoading = false;
  @observable type = 0; //设置对应页面展示的结果
  @observable ganttRecord = {};
  @observable btnLoading = false;
  @observable isSelectOrder = false;
  @observable masterData = []; // 获取的物料数据
  @observable orderData = []; // 获取的订单数据
  @observable supplierData = []; // 供应商的存储数据
  @observable clientData = []; // 供应商的存储数据
  @observable currentMaterial = "";
  @observable currentOrder = "";
  @observable printData = { vehicleOrderDO: {}, shipmentOrderVO: {} };
  @observable cardInfo = {};

  @observable searchData = {};
  /*  ===========生产任务 */
  @action async getMaster(params) {
    try {
      let res = await services.gets("getMaster")(params);
      if (isDataExist(res)) {
        this.masterData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async listByOrderStatue(params) {
    try {
      let res = await services.gets("listByOrderStatueFirstTen")(params);
      if (isDataExist(res)) {
        this.orderData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action.bound async getPlanList(params) {
    this.isLoading = true;
    this.planList = [];
    try {
      let res = await services.gets("getPlanList")({
        ...omit(this.planPageInfo, "total"),
        ...params
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        res.data.data.items.map(item=>{
          item.address1=item.order&&item.order.address1||""
          item.address2=item.order&&item.order.address2||''
          item.address3=item.order&&item.order.address3||''
          item.address4=item.order&&item.order.address4||''
          item.address5=item.order&&item.order.address5||''
          item.remark1=item.order&&item.order.remark||''
          item.remark2=item.order&&item.order.remark2||''
          return item
        })
        this.planList = res.data.data.items;
        this.planPageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  /* 获取订单数据 */
  @action async getOrderList() {
    this.plan_orderList = [];
    try {
      let res = await services.gets("getOrderList")();
      if (isDataExist(res)) {
        this.plan_orderList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async getBomList(params) {
    this.plan_bomList = [];
    try {
      let res = await services.gets("getBomList")(params);
      if (isDataExist(res)) {
        this.plan_bomList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action async getClient(params){
    try{
     let res=await services.gets('getClient')(params);
     if(isDataExist(res)){
   this.clientData=res.data.data
     }
    }catch(error){
      console.log(error)
    }
  }

@action async getSaveToEnd(params){
  try{
  let res=await services.posts('saveToEnd')(params);
  if(isDataExist(res)){
    message.success('完结操作成功')
  }
  }catch(error){
    console.log(error)
  }
}


 @action async getSupplier(params){ //计划管理-生产任务-供应商下拉接口
   try{
    let res=await services.gets('getSupplier')(params);
    if(isDataExist(res)){
    this.supplierData=res.data.data
    }
   }catch(error){
     console.log(error)
   }
 }

  @action async getRouteList(params) {
    this.route_bomList = [];
    try {
      let res = await services.gets("getRouteList")(params);
      console.log("res:", res.data.data);
      if (isDataExist(res)) {
        this.route_bomList = res.data.data;
        return res.data.data
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action async setOrderValue(params) {
    try {
      let res = await services.gets("setOrderValue")(params);
      if (isDataExist(res)) {
        this.planByOrder = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async savePlan(params) {
    try {
      let res = await services.posts("savePlan")(params);
      if (isDataExist(res)) {
        this.queryPlanList();
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async saveByOrder(params) {
    try {
      let res = await services.posts("saveByOrder")(params);
      if (isDataExist(res)) {
        this.queryPlanList();
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async getEditPlan(params) {
    this.modalLoading = true;
    try {
      let res = await services.gets("editPlan")(params);
      this.modalLoading = false;
      if (isDataExist(res)) {
        let data = res.data.data;
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async deletePlan(params, type) {
    try {
      let req = type === "batch" ? "batchRemove" : "removePlan";
      let res = await services.posts(req)(params);
      if (isDataExist(res)) {
        message.success("删除成功");
      }
    } catch (error) {
      console.log(error);
    }
    this.queryPlanList();
  }
  @action async toWork(params) {
    try {
      let res = await services.posts("toWork")(params);
      if (isDataExist(res)) {
        message.success("生产计划已排程");
      }
    } catch (error) {
      console.log(error);
    }
    this.queryPlanList();
  }
  @action.bound async onSyncData() {
    this.btnLoading = true;
    try {
      let res = await services.gets("toSyncData")();
      this.btnLoading = false;
      if (isDataExist(res)) {
        message.success("同步成功");
      }
    } catch (error) {
      message.success("同步失败");
      console.log(error);
    }
    this.getPlanList({
      planNo: this.planNo,
      pageSize: 10,
      pageIndex: 1
    });
  }
  queryPlanList = () => {
    this.getPlanList({
      planNo: this.planNo
    });
  };
  @action.bound showPlanModal(visible) {
    this.planModalVis = visible;
  }
  @action.bound showAddPlanModal(visible) {
    this.addPlanModalVis = visible;
  }
  // 2新
  @action.bound show_pai_cheng_modal(visible) {
    this.paiChengVis = visible;
  }
  @action.bound showPrintTable(visible) {
    this.printModalVis = visible;
    if (!visible) {
      this.getPlanList({
        pageSize: 10,
        pageIndex: 1,
        ...this.searchData
      });
    }
  }
  @action clearPlanModal() {
    this.planModalVis = false;
    this.addPlanModalVis = false;
    // 2新
    this.paiChengVis = false;
    // this.printModalVis = false;
    this.generateOrderId = "";
    // this.planCurrentRe = {};
    this.masterData = []; // 获取的物料数据
    this.orderData = []; // 获取的订单数据
  }
  @action async getPrint(params) {
    try {
      let res = await services.gets("translateCard")(params);
      if (isDataExist(res)) {
        this.cardInfo = res.data.data;
        let procedure = res.data.data.procedure;
        let arr = [];
        if (procedure) {
          arr = procedure.split("->");
          this.cardInfo.arr = arr;
        }
        console.log(res.data.data);
        console.log(arr);
        console.log(this.cardInfo.arr);
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* ============生产报工 */
  @observable reportBomId = "";
  @observable reportDevId = "";
  @observable reportWorkId = "";
  @observable report_deviceList = [];
  @observable reportList = [];
  @observable reportPage = { pageIndex: 1, pageSize: 10 };
  @observable reportVisible = false;
  @observable reportCurrent = {};
  @observable workerList = [];
  @observable rep_loading = false;
  @observable workerName = "";
  @observable editReportInfo = {};
  @observable inspectInfo = [];
  @observable inspectResult = [];
  @observable materialToReport = [];

  @action async getMaterialByWork(params) {
    try {
      let res = await services.gets("getMaterialByWork")(params);
      if (isDataExist(res)) {
        this.materialToReport = res.data.data;
        this.getWorkReport();
      }
    } catch (error) { }
  }
  @action async getDevice(params) {
    try {
      let res = await services.gets("getDevice")(params);
      if (isDataExist(res)) {
        this.report_deviceList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action async getWorkReport(data) {
    this.isLoading = true;
    this.reportList = [];
    try {
      let params = {
        // materialId: this.reportBomId || "",
        // workNo: this.reportWorkId || "",
        // deviceId: this.reportDevId || "",
        workStatus: 1,
        ...this.reportPage,
        ...data,
        ...this.searchData
      };
      let res = await services.gets("getWorkReport")(params);
      this.isLoading = false;
      if (isDataExist(res)) {
        this.reportList = res.data.data.items;
        this.reportPage = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async startUp(params) {
    try {
      let res = await services.posts("startUp")(params);
      if (isDataExist(res)) {
        message.success("工单开启成功");
      }
    } catch (error) {
      console.log(error);
    }
    this.getWorkReport();
  }

  /* 获取操作工 */
  @action async getWorker(params) {
    this.rep_loading = false;
    this.workerList = [];
    try {
      let res = await services.gets("getWorker")(params);
      this.rep_loading = true;
      if (isDataExist(res)) {
        this.workerList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async toComplete(params) {
    try {
      let res = services.posts("toComplete")(params);
      if (isDataExist(res)) {
        message.success("工单已完结");
      }
    } catch (error) {
      console.log(error);
    }
    this.getWorkReport();
  }
  /* 上报提交 */
  @action async updateReport(params) {
    try {
      let res = await services.posts("updateReport")(params);
      if (isDataExist(res)) {
        this.getWorkReport();
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  /* 质检提交 */
  @action async inspectReport(params) {
    try {
      let res = await services.posts("inspectReport")(params);
      if (isDataExist(res)) {
        message.success("添加质检结果成功");
      }
    } catch (error) {
      console.log(error);
    }
    this.getWorkReport();
  }
  /* 获取质检信息 */
  @action async getInspectInfo(params) {
    try {
      let res = await services.gets("getInspectInfo")(params);
      if (isDataExist(res)) {
        let data = res.data.data;
        let inspectResult = [];
        data.map(item => {
          inspectResult.push({
            inspectSchemaId: item.id,
            inspectId: item.inspectId,
            contentType: item.contentType,
            description: ""
          });
        });
        this.inspectResult = inspectResult;
        this.inspectInfo = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action changeInspectResult({ id, type, value }) {
    // let result = this.inspectResult;
    this.inspectResult.map(item => {
      if (item.inspectSchemaId === id) {
        if (type === "description") {
          item.description = value;
        }
        if (type === "radio") {
          item.boolValue = value;
        }
        if (type === "input") {
          item.doubleValue = value;
        }
      }
      return item.id;
    });
  }
  /*  =============== 生产分析 */
  @observable AnalysisData = [];
  @observable planList = [];
  @observable planDevName = "";

  @action async getAllStaticCount() {
    try {
      let resArray = [
        { req: "getMonthPlanCount", data: {}, type: "planVars" },
        { req: "getMonthWorkCount", data: {}, type: "workVars" },
        { req: "getDayWorkCont", data: {}, type: "execVars" },
        { req: "getDaySuccessCount", data: {}, type: "factVars" },
        { req: "getProductStatic", data: [], type: "productStatic" },
        { req: "getReportCountByDate", data: [], type: "workExecute" }
      ];
      for (let req of resArray) {
        let params = req.params || {};
        let res = await services.gets(req.req)(params);
        if (isDataExist(res)) {
          let data = res.data.data;
          if (req.type === "workExecute") {
            if (data.length > 0) {
              let list = [{ name: "successCount" }, { name: "failCount" }];
              for (let item of data) {
                list[0][item.reportTime] = item.successCount;
                list[1][item.reportTime] = item.failCount;
              }
              Object.assign(req, {
                data: list
              });
            }
          } else if (req.type === "productStatic") {
            let list = [];
            for (let item of data) {
              list.push({
                year: item.reportTime,
                value: item.successCount
              });
            }
            Object.assign(req, {
              data: list
            });
          } else {
            Object.assign(req, {
              data
            });
          }
        }
      }

      this.AnalysisData = resArray;
    } catch (error) { }
  }
  @action async getPlantList(params) {
    this.isPlantLoading = true;
    this.planList = [];
    try {
      let res = await services.gets("getListWork")({
        devName: this.planDevName,
        ...params
      });
      this.isPlantLoading = false;
      if (isDataExist(res)) {
        this.planList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action changeVisible = visible => {
    this.reportVisible = visible;
  };
  @action clearData() {
    this.reportBomId = "";
    this.reportDevId = "";
    this.reportWorkId = "";
    this.report_deviceList = [];
    this.reportList = [];
    this.reportPage = { pageIndex: 1, pageSize: 10 };
    this.selectedRowKeys = [];
    this.selectedRows = [];
    this.reportVisible = false;
    this.reportCurrent = {};
    this.workerList = [];
    this.rep_loading = false;
    this.workerName = "";
    this.editReportInfo = {};
    this.inspectInfo = [];
    this.inspectResult = [];
    this.searchData = {};
    this.supplierData=[];
    this.clientData=[]
  }
  //生成打样单
  @action.bound async proofing(params) {
    this.isLoading = true;
    try {
      let res = await services.posts("proofing")(params);
      this.isLoading = false;
      if (isDataExist(res)) {
        message.success("打样成功");
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* ============计件报表 */

  @observable isPieceLoading = false;
  @observable pieceworkData = [];
  @observable startTime = "";
  @observable piecePageInfo = {
    pageIndex: 1,
    pageSize: 10
  };
  @observable tenantId = "";
  @observable pieceSearchData = {};
  @action.bound async getPieceworkList(params) {
    this.isPieceLoading = true;
    this.pieceworkData = [];
    try {
      let res = await services.gets("getPieceworkList")({
        ...omit(this.piecePageInfo, "total"),
        ...params
      });
      this.isPieceLoading = false;
      if (isDataExist(res)) {
        this.pieceworkData = res.data.data.items;
        this.piecePageInfo = res.data.data.page;
        this.tenantId = res.data.data.items
          ? res.data.data.items[0].tenantId
          : "";
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async export(params) {
    this.isLoading = true;
    try {
      let res = await services.gets("export")(params);
      this.isLoading = false;
      console.log(res);
      // if (isDataExist(res)) {
      //   message.success("导出成功");
      // }
    } catch (error) {
      console.log(error);
    }
  }
  @action clearPieceData() {
    this.isPieceLoading = false;
    this.pieceworkData = [];
    this.tenantId = "";
    this.piecePageInfo = {
      pageIndex: 1,
      pageSize: 10
    };
    this.pieceSearchData = {}
  }
}

let ProductionStore = new Production();
export default ProductionStore;
